import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { agentKeyAtom } from 'views/Findings/state';
import {
  checkedListAtom,
  filterValuesAtom,
  isCheckAllAtom,
  orderByAtom,
  paginationConfigAtom,
  selectedCloudAgentsFilterAtom,
  serverOrWorkstationFilterAtom,
} from './CAList/state';
import { caTypeAtom, appliedCAIdsAtom } from '../CADashboard/state';

export function useOnCompanyChangeCAResetAtoms() {
  const resetSelectedCAIds = useResetAtom(appliedCAIdsAtom);
  const resetCaTypeAtom = useResetAtom(caTypeAtom);
  const resetOrderbyAtom = useResetAtom(orderByAtom);
  const resetCheckedListAtom = useResetAtom(checkedListAtom);
  const resetIsCheckAllAtom = useResetAtom(isCheckAllAtom);
  const resetSelectedCloudAgentsFilterAtom = useResetAtom(
    selectedCloudAgentsFilterAtom,
  );
  const resetServerOrWorkstationFilterAtom = useResetAtom(
    serverOrWorkstationFilterAtom,
  );
  const [paginationConfig, setPaginationConfig] = useAtom(paginationConfigAtom);
  const resetAgentKeyAtom = useResetAtom(agentKeyAtom);
  const resetFilterValuesAtom = useResetAtom(filterValuesAtom);

  const resetAtoms = () => {
    resetSelectedCAIds();
    resetCaTypeAtom();
    resetOrderbyAtom();
    resetCheckedListAtom();
    resetIsCheckAllAtom();
    resetSelectedCloudAgentsFilterAtom();
    resetServerOrWorkstationFilterAtom();
    // Only reset page number, preserve page size
    setPaginationConfig({
      ...paginationConfig,
      page: 1,
    });
    resetAgentKeyAtom();
    resetFilterValuesAtom();
  };

  return resetAtoms;
}
